export default "__VITE_ASSET__B7IiI8rC__"